export default __webpack_public_path__ + "static/media/icomoon.b4c55861.eot";